import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { confirmSubmitModalStyles as sx } from './ConfirmSubmitModal/ConfirmSubmitModal.styles';

type Props = {
	previousDisplay: string | null;
	newDisplay: string;
	isNewField: boolean;
};

export const FieldChange = ({
	previousDisplay,
	newDisplay,
	isNewField
}: Props) => {
	const { t } = useTranslation();

	if (isNewField) {
		return (
			<>
				<Typography component='span' variant='body2' sx={[sx.tag, sx.addedTag]}>
					{t('Added')}
				</Typography>
				<Typography component='span' variant='body2' sx={sx.newValue}>
					{newDisplay}
				</Typography>
			</>
		);
	}

	if (!newDisplay) {
		return (
			<>
				<Typography
					component='span'
					variant='body2'
					sx={[sx.tag, sx.removedTag]}
				>
					{t('Removed')}
				</Typography>
				<Typography component='span' variant='body2' sx={sx.removedValue}>
					{previousDisplay}
				</Typography>
			</>
		);
	}

	return (
		<>
			<Typography component='span' variant='body2' sx={sx.previousValue}>
				{previousDisplay}
			</Typography>
			<ArrowRightAltIcon sx={sx.arrowIcon} />
			<Typography component='span' variant='body2' sx={sx.newValue}>
				{newDisplay}
			</Typography>
		</>
	);
};
